(function () {
    'use strict';

    angular.module('showcaseApp')
        .controller('SalesFunnelController', SalesFunnelController);

    /** @ngInject */
    function SalesFunnelController($scope, $rootScope, SalesFunnelService, toastr, $translate, $timeout, $localStorage, $uibModal, MODAL_CONTENT_TYPES, UserService, CustomerService, TagService, moment, $window, systemConstants) {
        var vm = this;

        var isUpdating = false;
        var userId = $localStorage.userId;
        var storeId = $localStorage.defaultStore.storeId;
        var filterLocalStorageKey = 'negotiation_filter_' + userId + '_' + storeId;
        const DATE_FORMAT = $translate.instant('momentDateFormat');

        vm.isLoading = false;
        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;
        vm.listSellerFilterOptions = UserService.getUsersSellersByStore;
        vm.listCustomerFilterOptions = CustomerService.getCustomersByStore;
        vm.listTagsFilterOptions = TagService.getTagsByStore;
        vm.loggedUser = getDynamicFilterOptionsModel(true);
        vm.loggedUser.only = [$localStorage.userId]
        vm.columns = [];
        vm.cardWallId = 0;

        vm.sortableOptions = {
            connectWith: '.list-group',
            placeholder: 'list-group-item placeholder',
            tolerance: 'pointer',
            update: function (event, ui) {

                if (isUpdating) return;

                isUpdating = true;

                var sourceColumn = ui.item.sortable.sourceModel;
                var targetColumn = ui.item.sortable.droptargetModel;
                var movedNegotiation = sourceColumn.negotiations.find(function (negotiation, index) {
                    return index === ui.item.sortable.index;
                });

                var sourceColumnId = sourceColumn.id;
                var targetColumnId = targetColumn.id;

                if (sourceColumnId !== targetColumnId) {
                    updateNegotiation(movedNegotiation, sourceColumnId, targetColumnId, getNewPosition(ui.item.sortable.dropindex));
                } else {
                    updatePositionOnly(movedNegotiation, getNewPosition(ui.item.sortable.dropindex), sourceColumnId);
                }
            }
        };

        vm.deliverySinceDate = '';
        vm.deliveryUntilDate = '';

        vm.dynamicFilterOptions = {
            sellers: getDynamicFilterOptionsModel(true),
            customers: getDynamicFilterOptionsModel(true),
            tags: getDynamicFilterOptionsModel(true)
        }


        vm.addNewColumn = addNewColumn;
        vm.saveNewColumn = saveNewColumn;
        vm.cancelNewColumn = cancelNewColumn;
        vm.deleteColumn = deleteColumn;

        init();

        vm.recalculateTotals = recalculateTotals;

        $scope.$watch(
            function () {
                return vm.columns.map(function (col) {
                    return {
                        lengths: (col.negotiations || []).length,
                        prices: (col.negotiations || []).map(function (n) {
                            return n.salesPrice;
                        })
                    };
                });
            },
            function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    vm.recalculateTotals();
                }
            },
            true
        );

        function init() {
            vm.isLoading = true;
            initializeFiltersStructure();
            loadCardWall();
        }

        vm.hasFilters =  function () {
            if (vm.filters.sellerSelection && vm.filters.sellerSelection.length > 0) {
                return true;
            } else if (vm.filters.customerSelection && vm.filters.customerSelection.length > 0) {
                return true;
            } else if (vm.filters.sinceDate || vm.filters.untilDate) {
                return true;
            } else {
                return false;
            }
        }

        function getDefaultFilters() {
            return {
                title: "",
                sellerSelection: vm.loggedUser.only
            };
        }

        function getDefaultNegotiationFilter() {
            return {
                sellerKeys: [],
                sellerKey: undefined,
                sellerSelection: vm.loggedUser
            };
        }

        function getEmptyFilters() {
            return {
                title: "",
                sellerSelection: [],
                customerSelection: [],
                tagSelection: []
            };
        }

        function getEmptyNegotiationFilter() {
            return {
                sellerKeys: [],
                sellerKey: undefined,
                sellerSelection: getSelectAllPaginatedModel(),
                customerSelection: getSelectAllPaginatedModel(),
                tagSelection:getSelectAllPaginatedModel()
            };
        }

        function initializeFiltersStructure() {

            if (!$localStorage[filterLocalStorageKey]) {
                $localStorage[filterLocalStorageKey] = {
                    filters: getDefaultFilters(),
                    negotiationFilter: getDefaultNegotiationFilter()
                };
            }

            var storage = $localStorage[filterLocalStorageKey];

            if (!storage.filters) {
                storage.filters = getDefaultFilters();
            }

            if (storage.negotiationFilter) {
                delete storage.negotiationFilter.sinceDate;
                delete storage.negotiationFilter.untilDate;
            }

            if (!storage.negotiationFilter) {
                storage.negotiationFilter = getDefaultNegotiationFilter();
            }

            vm.negotiationFilter = storage.negotiationFilter || getDefaultNegotiationFilter();
            vm.filters = storage.filters || getDefaultFilters();

            if (storage.filters.sinceDate) {
                vm.deliverySinceDate = moment(storage.filters.sinceDate).format(DATE_FORMAT);
            }

            if (storage.filters.untilDate) {
                vm.deliveryUntilDate = moment(storage.filters.untilDate).format(DATE_FORMAT);
            }
            vm.searchText = vm.filters.title || "";
        }

        vm.loadDeliveryDateFilter = function() {
            loadDateFilter('deliverySinceDate', vm.filters.sinceDate);
            loadDateFilter('deliveryUntilDate', vm.filters.untilDate);
        }


        function loadDateFilter(filterKey, dateValue) {
            if (dateValue) {
                vm[filterKey] = moment(dateValue).format(DATE_FORMAT).toString();
            } else {
                vm[filterKey] = '';
            }
            loadCardWall();
        }

        vm.collectDeliveryDateFilter = function () {
            collectDateFilter('sinceDate', vm.deliverySinceDate);
            collectDateFilter('untilDate', vm.deliveryUntilDate);
            loadDateFilter();
        }

        function collectDateFilter(filterField, filterValue) {
            if (angular.isString(filterValue) && filterValue.length > 0) {
                vm.filters[filterField] = moment(
                    filterValue,
                    DATE_FORMAT
                ).format("YYYY-MM-DD");
            } else {
                delete vm.filters[filterField];
            }
        }

        vm.loadFilter = function (filterType, listKey, singleKey, valueKey, paginatedSelectionKey) {
            var filterOptions = vm.negotiationFilter[filterType];

            if (angular.isArray(filterOptions) || !paginatedSelectionKey) {
                if (filterOptions.length > 0) {
                    var formatedList = filterOptions.map(function (item) {
                        return item[valueKey];
                    });

                    vm.filters[listKey] = formatedList;

                    if (singleKey && formatedList.length > 0) {
                        vm.filters[singleKey] = formatedList[0];
                    }
                } else {
                    delete vm.filters[listKey];
                    if (singleKey) {
                        delete vm.filters[singleKey];
                    }
                }
            } else {
                if (paginatedSelectionKey) {
                    var formatedPaginatedSelection = angular.copy(filterOptions);

                    if (formatedPaginatedSelection.except) {
                        formatedPaginatedSelection.except = formatedPaginatedSelection.except.map(function (item) {
                            if(item[valueKey]) {
                                return item[valueKey];
                            } else {
                                return item;
                            }
                        });
                    }

                    if (formatedPaginatedSelection.only) {
                        formatedPaginatedSelection.only = formatedPaginatedSelection.only.map(function (item) {
                            if(item[valueKey]) {
                                return item[valueKey];
                            } else {
                                return item;
                            }
                        });
                    }

                    vm.filters[paginatedSelectionKey] = formatedPaginatedSelection.only;
                } else {
                    delete vm.filters[paginatedSelectionKey];
                }
            }

            loadCardWall();
        };

        function loadCardWall() {
            SalesFunnelService.getCardWall(vm.filters)
                .then(function (response) {
                    vm.cardWallId = response.data.id;
                    vm.totalValue = response.data.totalCardWallValue;
                    vm.columns = response.data.salesFunnelStages;
                    $localStorage[filterLocalStorageKey].filters = vm.filters;
                    $localStorage[filterLocalStorageKey].negotiationFilter = vm.negotiationFilter;
                    vm.isLoading = false;
                })
                .catch(function (error) {
                    vm.isLoading = false;
                    toastr.error(error.message);
                });
        }

        vm.clearFilters = function () {
            vm.filters = getEmptyFilters();
            vm.negotiationFilter = getEmptyNegotiationFilter();
            vm.deliverySinceDate = '';
            vm.deliveryUntilDate = '';

            $localStorage[filterLocalStorageKey] = {
                filters: vm.filters,
                negotiationFilter: vm.negotiationFilter
            };
            loadCardWall();
        };

        vm.hasFilters = function () {
            return (
                (vm.filters.sellerSelection && vm.filters.sellerSelection.length > 0) ||
                (vm.filters.customerSelection && vm.filters.customerSelection.length > 0) ||
                (vm.filters.tagSelection && vm.filters.tagSelection.length > 0) ||
                vm.filters.sinceDate ||
                vm.filters.untilDate ||
                (vm.filters.title && vm.filters.title.trim() !== "")
            );
        };

        vm.searchChange = function() {
            if (!vm.searchText || vm.searchText.trim() === "") {
                vm.filters.title = "";
            } else {
                vm.filters.title = vm.searchText.trim();
            }

            loadCardWall();
        }


        vm.negotiationActions = [
            {
                icon: 'icon-ksc-pen-to-square-regular',
                label: $translate.instant("salesFunnel.actions.edit"),
                method: function (item) {
                    vm.openEditNegotiationMenu(item.id);
                }
            },
            {
                icon: 'icon-ksc-trash-regular',
                label: $translate.instant("salesFunnel.actions.delete"),
                method: function (item) {
                    vm.deleteNegotiation(item.id);
                }
            }
        ];

        vm.openEditNegotiationMenu = function (itemId) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    content: function () {
                        return {
                            negotiationId: itemId,
                            columns: vm.columns,
                            isImmoContext: vm.isImmoContext || false,
                            title: $translate.instant('salesFunnel.label.negotiation'),
                            cancelButtonText: $translate.instant('salesFunnel.button.cancel'),
                            confirmButtonText: $translate.instant('salesFunnel.button.save'),
                            type: MODAL_CONTENT_TYPES.NEGOTIATION
                        }
                    }
                }
            });

            var unbindRouteChange = $rootScope.$on('$locationChangeStart', function() {
                modalInstance.dismiss('route change');
            });

            modalInstance.result.then(function (updatedNegotiation) {
                vm.negotiation = updatedNegotiation;
                updateColumns(itemId, updatedNegotiation);

                $rootScope.$applyAsync();
                unbindRouteChange();
            }, function () {
                unbindRouteChange();
            });
        }

        function updateColumns(itemId, updatedNegotiation) {
            var stage = getSalesFunnelStage(itemId, vm.columns);

            var previousColumn = vm.columns.find(function (column) {
                return column.id === stage.id;
            });

            if (previousColumn) {
                previousColumn.negotiations = previousColumn.negotiations.filter(function (n) {
                    return n.id !== vm.negotiation.id;
                }).map(function (n, i) {
                    n.position = i + 1;
                    return n;
                });

                previousColumn.negotiations.sort(function (a, b) {
                    return a.position - b.position;
                });
            }

            var newColumn = vm.columns.find(function (column) {
                return column.id === updatedNegotiation.salesFunnelStageId;
            });

            if (newColumn) {
                newColumn.negotiations.splice(updatedNegotiation.position - 1, 0, vm.negotiation)

                newColumn.negotiations = newColumn.negotiations.map(function (n, i) {
                    n.position = i + 1
                    return n
                })

                newColumn.negotiations.sort(function (a, b) {
                    return a.position - b.position;
                });
            }
        }

        vm.deleteNegotiation = function (itemId) {
            if (itemId) {
                SalesFunnelService.deleteNegotiation(itemId)
                    .then(function () {
                        var stage = getSalesFunnelStage(itemId, vm.columns);

                        if (stage) {
                            const index = stage.negotiations.findIndex(function (negotiation) {
                                return negotiation.id === itemId;
                            });
                            if (index !== -1) {
                                stage.negotiations.splice(index, 1);
                            }
                        }

                        toastr.success(
                            $translate.instant(
                                "salesFunnel.success.deletedNegotiation"
                            )
                        );
                    })
                    .catch(function (error) {
                        toastr.error(error.message);
                    });
            }
        };

        function addNewColumn() {
            var lastPosition = vm.columns.reduce(function (max, column) {
                return Math.max(max, column.position);
            }, 0);
            vm.newColumn = {
                id: undefined,
                title: '',
                negotiations: [],
                position: lastPosition + 1,
                lastStage: false,
                salesFunnelCardWallId: vm.cardWallId
            };

            $timeout(function () {
                document.querySelector('.funnel-columns-container input').focus();
            });
        }

        function saveNewColumn() {
            if (vm.newColumn.title.trim()) {
                SalesFunnelService.addStage(vm.newColumn)
                    .then(function (response) {
                        var savedColumn = response.data;
                        vm.newColumn.id = savedColumn.id;
                        toastr.success($translate.instant('salesFunnel.success.createdColumn'));
                        vm.columns.push(angular.copy(vm.newColumn));
                        vm.newColumn = null;
                    })
                    .catch(function (error) {
                        if (error.data.data.fieldErrors[0].message === 'Size') {
                            toastr.error($translate.instant('salesFunnel.error.exceedsCharLimitError'));
                        }
                        else {
                            toastr.error(error.message);
                        }
                    });
            }
        }

        function cancelNewColumn() {
            vm.newColumn = null;
        }

        function deleteColumn(column) {
            SalesFunnelService.deleteStage(column.id)
                .then(function () {
                    vm.columns = vm.columns.filter(function (col) {
                        return col.id !== column.id;
                    });
                    toastr.success($translate.instant('salesFunnel.success.deletedColumn'));
                })
                .catch(function (error) {
                    toastr.error(error.message);
                });
        }

        function getNewPosition(index, s) {
            return index + 1;
        }

        function updateNegotiation(negotiation, previousColumnId, newColumnId, newPosition) {
            var previousPosition = negotiation.position;

            negotiation.salesFunnelStageId = newColumnId;
            negotiation.position = newPosition;

            SalesFunnelService.updateNegotiationStage(negotiation.id, {
                salesFunnelStageId: newColumnId,
                position: newPosition
            }).then(function () {
                var previousColumn = vm.columns.find(function (column) {
                    return column.id === previousColumnId;
                });

                if (previousColumn) {
                    previousColumn.negotiations = previousColumn.negotiations.filter(function (n) {
                        return n.id !== negotiation.id;
                    }).map(function (n, i) {
                        n.position = i + 1;
                        return n;
                    });

                    previousColumn.negotiations.sort(function (a, b) {
                        return a.position - b.position;
                    });

                    if (typeof previousColumn.totalNegotiations === 'number') {
                        previousColumn.totalNegotiations = Math.max(0, previousColumn.totalNegotiations - 1);
                    }
                }

                var newColumn = vm.columns.find(function (column) {
                    return column.id === newColumnId;
                });

                if (newColumn) {
                    newColumn.negotiations.splice(newPosition - 1, 0, negotiation)

                    newColumn.negotiations = newColumn.negotiations.map(function (n, i) {
                        n.position = i + 1
                        return n
                    })

                    newColumn.negotiations.sort(function (a, b) {
                        return a.position - b.position;
                    });

                    if (typeof newColumn.totalNegotiations === 'number') {
                        newColumn.totalNegotiations = newColumn.totalNegotiations + 1;
                    }
                }

                $rootScope.$applyAsync();
                isUpdating = false;
            })
                .catch(function (error) {
                    toastr.error(error.message);
                    rollback(negotiation, previousColumnId, previousPosition);
                    isUpdating = false;
                });
        }

        function updatePositionOnly(negotiation, newPosition, previousColumnId) {
            var previousPosition = negotiation.position;

            negotiation.position = newPosition;

            SalesFunnelService.updateNegotiationStage(negotiation.id, {
                position: newPosition,
                salesFunnelStageId: previousColumnId
            }).then(function () {
                var currentColumn = vm.columns.find(function (column) {
                    return column.id === previousColumnId;
                });

                if (currentColumn) {
                    if (previousPosition > 0 && previousPosition <= currentColumn.negotiations.length) {
                        var item = currentColumn.negotiations.splice(previousPosition - 1, 1)[0];

                        currentColumn.negotiations.splice(newPosition - 1, 0, item)
                    }

                    currentColumn.negotiations = currentColumn.negotiations.map(function (n, i) {
                        n.position = i + 1
                        return n
                    })

                    currentColumn.negotiations.sort(function (a, b) {
                        return a.position - b.position;
                    });
                }

                $rootScope.$applyAsync();
                isUpdating = false;
            })
                .catch(function (error) {
                    toastr.error(error.message);
                    rollback(negotiation, null, previousPosition);
                    isUpdating = false;
                });
        }

        function rollback(negotiation, previousColumnId, previousPosition) {
            if (previousColumnId) {
                negotiation.salesFunnelStageId = previousColumnId;
            }
            negotiation.position = previousPosition;

            $rootScope.$applyAsync();
        }

        vm.openFiltersModal = function () {
            var filtersModal = $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                backdrop: 'static',
                controllerAs: 'vm',
                keyboard: false,
                resolve: {
                    content: function () {
                        return {
                            title: $translate.instant('flyers.filters.modalTitle'),
                            cancelButtonText: $translate.instant('flyers.button.cancel'),
                            confirmButtonText: $translate.instant('flyers.filters.apply'),
                            options: {
                                dynamicFilterOptions: vm.dynamicFilterOptions,
                                listSellerFilterOptions: function () {return UserService.getUsersSellersByStore;},
                                listCustomersFilterOptions: function () {return CustomerService.getCustomersByStore;},
                                listTagsFilterOptions: function () {return TagService.getTagsByStore;},
                                sinceDate: vm.deliverySinceDate,
                                untilDate: vm.deliveryUntilDate
                            },
                            filters: vm.filters,
                            list: vm.negotiationFilter,
                            isImmoContext: vm.isImmoContext,
                            type: MODAL_CONTENT_TYPES.NEGOTIATION_FILTERS
                        }
                    }
                },
            });
            var unbindRouteChange = $rootScope.$on('$locationChangeStart', function() {
                filtersModal.dismiss('route change');
            });

            filtersModal.result.then(function (response) {
                vm.filters.sellerSelection = response.listFilter.sellerSelection.only;
                vm.filters.customerSelection = response.listFilter.customerSelection.only;
                vm.filters.tagSelection = response.listFilter.tagSelection.only;
                vm.deliverySinceDate = response.filtered.sinceDate;
                vm.deliveryUntilDate = response.filtered.untilDate;

                collectDateFilter('sinceDate', vm.deliverySinceDate);
                collectDateFilter('untilDate', vm.deliveryUntilDate);

                delete vm.negotiationFilter.sinceDate;
                delete vm.negotiationFilter.untilDate;

                loadCardWall();
            }, function () {
                unbindRouteChange();
            });
        }

        vm.formatMoney = function (value) {
            var currencyConfigurations = $localStorage.defaultStore.storeInfo.currencyConfiguration;
            if(!currencyConfigurations) {
                return
            }
            if (!value) {
                return $translate.instant('salesFunnel.label.negotiation-total') + formatMoney(0, currencyConfigurations.prefix, currencyConfigurations.decimalQuant,
                    currencyConfigurations.centsSeparator, currencyConfigurations.thousandsSeparator);
            }
            return $translate.instant('salesFunnel.label.negotiation-total') + formatMoney(value, currencyConfigurations.prefix, currencyConfigurations.decimalQuant,
                currencyConfigurations.centsSeparator, currencyConfigurations.thousandsSeparator);
        };

        function recalculateTotals () {
            if (!vm.columns) return;

            vm.columns.forEach(function (col) {
                var negotiations = col.negotiations || [];


                col.totalStageValue = negotiations.reduce(function (sum, n) {
                    return sum + (n.salesPrice || 0);
                }, 0);

            });

            vm.totalValue = vm.columns.reduce(function (sum, col) {
                return sum + (col.totalStageValue || 0);
            }, 0);

            $rootScope.$applyAsync();
        }
    }
})();
